import { NgModule } from '@angular/core';
import { SvgIconComponent } from './svg-icon.component';

@NgModule({
  declarations: [
    SvgIconComponent
  ],
  exports: [
    SvgIconComponent
  ]
})

export class SvgIconModule {}
